import { VENDOR, type VendorCode } from './vendorDisplayName'

// Keep in sync with backend migration 0095_vendor_robot_type_and_backfill.py
const AUTONOMICS_TYPE_DISPLAY: Record<string, string> = {
  Sweeper: 'Autonomics Sweeper',
  Combo: 'Autonomics Combo',
}

const GAUSIUM_TYPE_DISPLAY: Record<string, string> = {
  '75': 'GS Scrubber 75',
  '50': 'GS Omnie',
  '40': 'GS Vacuum 40',
  S: 'GS Phantas',
}

export function getRobotTypeDisplayName(
  vendor: VendorCode | string | undefined,
  typeCode: string | null | undefined
): string {
  const code = (typeCode || '').trim()
  if (!code || code === 'Unknown') return ''

  if (vendor === VENDOR.AUTONOMICS) {
    return AUTONOMICS_TYPE_DISPLAY[code] || code
  }

  if (vendor === VENDOR.GAUSIUM) {
    return GAUSIUM_TYPE_DISPLAY[code] || code
  }

  return code
}
